import { PseudoData } from './PseudoGenerator';

/**
 * French pseudo generation data for anonymous gameplay
 * Includes fun adjectives, origins, capacities and names with emojis
 */
export const pseudoData: PseudoData = {
  "complements": {
    "adjectives": [
      { "m": "absurde", "f": "absurde" },
      { "m": "agile", "f": "agile" },
      { "m": "amusant", "f": "amusante" },
      { "m": "astral", "f": "astrale" },
      { "m": "bancal", "f": "bancale" },
      { "m": "barbouillé", "f": "barbouillée" },
      { "m": "biscornu", "f": "biscornue" },
      { "m": "bling-bling", "f": "bling-bling" },
      { "m": "bruyant", "f": "bruyante" },
      { "m": "burlesque", "f": "burlesque" },
      { "m": "cabossé", "f": "cabossée" },
      { "m": "caramélisé", "f": "caramélisée" },
      { "m": "chatoyant", "f": "chatoyante" },
      { "m": "clignotant", "f": "clignotante" },
      { "m": "colossal", "f": "colossale" },
      { "m": "croustillant", "f": "croustillante" },
      { "m": "curieux", "f": "curieuse" },
      { "m": "délirant", "f": "délirante" },
      { "m": "dentelé", "f": "dentelée" },
      { "m": "dodu", "f": "dodue" },
      { "m": "douillet", "f": "douillette" },
      { "m": "duveteux", "f": "duveteuse" },
      { "m": "éblouissant", "f": "éblouissante" },
      { "m": "électrique", "f": "électrique" },
      { "m": "énigmatique", "f": "énigmatique" },
      { "m": "épique", "f": "épique" },
      { "m": "explosif", "f": "explosive" },
      { "m": "fabuleux", "f": "fabuleuse" },
      { "m": "farfelu", "f": "farfelue" },
      { "m": "flamboyant", "f": "flamboyante" },
      { "m": "flottant", "f": "flottante" },
      { "m": "folichon", "f": "folichonne" },
      { "m": "fougueux", "f": "fougueuse" },
      { "m": "fripé", "f": "fripée" },
      { "m": "frétillant", "f": "frétillante" },
      { "m": "givré", "f": "givrée" },
      { "m": "gluant", "f": "gluante" },
      { "m": "grandiose", "f": "grandiose" },
      { "m": "grotesque", "f": "grotesque" },
      { "m": "illuminé", "f": "illuminée" },
      { "m": "improbable", "f": "improbable" },
      { "m": "indestructible", "f": "indestructible" },
      { "m": "ingénieux", "f": "ingénieuse" },
      { "m": "insolite", "f": "insolite" },
      { "m": "invisible", "f": "invisible" },
      { "m": "jovial", "f": "joviale" },
      { "m": "jubilant", "f": "jubilante" },
      { "m": "légendaire", "f": "légendaire" },
      { "m": "lumineux", "f": "lumineuse" },
      { "m": "majestueux", "f": "majestueuse" },
      { "m": "maladroit", "f": "maladroite" },
      { "m": "malicieux", "f": "malicieuse" },
      { "m": "mignon", "f": "mignonne" },
      { "m": "moelleux", "f": "moelleuse" },
      { "m": "mystérieux", "f": "mystérieuse" },
      { "m": "nébuleux", "f": "nébuleuse" },
      { "m": "nerveux", "f": "nerveuse" },
      { "m": "ondoyant", "f": "ondoyante" },
      { "m": "opaque", "f": "opaque" },
      { "m": "palpitant", "f": "palpitante" },
      { "m": "pétillant", "f": "pétillante" },
      { "m": "pimpant", "f": "pimpante" },
      { "m": "pixelisé", "f": "pixelisée" },
      { "m": "poudreux", "f": "poudreuse" },
      { "m": "psychédélique", "f": "psychédélique" },
      { "m": "radieux", "f": "radieuse" },
      { "m": "rebondissant", "f": "rebondissante" },
      { "m": "robuste", "f": "robuste" },
      { "m": "ronchon", "f": "ronchonne" },
      { "m": "rutilant", "f": "rutilante" },
      { "m": "scintillant", "f": "scintillante" },
      { "m": "sidéral", "f": "sidérale" },
      { "m": "spatial", "f": "spatiale" },
      { "m": "spongieux", "f": "spongieuse" },
      { "m": "splendide", "f": "splendide" },
      { "m": "stellaire", "f": "stellaire" },
      { "m": "sucré", "f": "sucrée" },
      { "m": "survolté", "f": "survoltée" },
      { "m": "tordu", "f": "tordue" },
      { "m": "tourbillonnant", "f": "tourbillonnante" },
      { "m": "tropical", "f": "tropicale" },
      { "m": "turbulent", "f": "turbulente" },
      { "m": "velu", "f": "velue" },
      { "m": "vibrant", "f": "vibrante" },
      { "m": "virevoltant", "f": "virevoltante" },
      { "m": "vivace", "f": "vivace" },
      { "m": "volcanique", "f": "volcanique" },
      { "m": "vorace", "f": "vorace" },
      { "m": "zinzin", "f": "zinzinette" },
      { "m": "acrobatique", "f": "acrobatique" },
      { "m": "alambiqué", "f": "alambiquée" },
      { "m": "ambigu", "f": "ambiguë" },
      { "m": "baroque", "f": "baroque" },
      { "m": "bavard", "f": "bavarde" },
      { "m": "bizarre", "f": "bizarre" },
      { "m": "bourru", "f": "bourrue" },
      { "m": "brinquebalant", "f": "brinquebalante" },
      { "m": "capricieux", "f": "capricieuse" },
      { "m": "chahuteur", "f": "chahuteuse" },
      { "m": "chancelant", "f": "chancelante" },
      { "m": "chimérique", "f": "chimérique" },
      { "m": "cocasse", "f": "cocasse" },
      { "m": "coquin", "f": "coquine" },
      { "m": "délicieux", "f": "délicieuse" },
      { "m": "déluré", "f": "délurée" },
      { "m": "ébouriffé", "f": "ébouriffée" },
      { "m": "effervescent", "f": "effervescente" },
      { "m": "espiègle", "f": "espiègle" },
      { "m": "extravagant", "f": "extravagante" },
      { "m": "facétieux", "f": "facétieuse" },
      { "m": "fantasque", "f": "fantasque" },
      { "m": "farceur", "f": "farceuse" },
      { "m": "fringant", "f": "fringante" },
      { "m": "guilleret", "f": "guillerette" },
      { "m": "hilarant", "f": "hilarante" },
      { "m": "loufoque", "f": "loufoque" },
      { "m": "louche", "f": "louche" },
      { "m": "lourdaud", "f": "lourdaude" },
      { "m": "malicieux", "f": "malicieuse" },
      { "m": "nostalgique", "f": "nostalgique" },
      { "m": "pétaradant", "f": "pétaradante" },
      { "m": "pittoresque", "f": "pittoresque" },
      { "m": "rieur", "f": "rieuse" },
      { "m": "rigolo", "f": "rigolote" },
      { "m": "saugrenu", "f": "saugrenue" },
      { "m": "sautillant", "f": "sautillante" },
      { "m": "taquin", "f": "taquine" },
      { "m": "toupie", "f": "toupie" },
      { "m": "truculent", "f": "truculente" },
      { "m": "vagabond", "f": "vagabonde" },

      /* -- AJOUTS NOUVEAUX -- */
      { "m": "crépitant", "f": "crépitante" },
      { "m": "frisottant", "f": "frisottante" },
      { "m": "rêvassant", "f": "rêvassante" },
      { "m": "bulleux", "f": "bulleuse" },
      { "m": "clapotant", "f": "clapotante" },
      { "m": "froufroutant", "f": "froufroutante" },
      { "m": "gazouillant", "f": "gazouillante" },
      { "m": "miroitant", "f": "miroitante" },
    ],

    "origins": [
      "des marais",
      "de la forêt profonde",
      "des montagnes brumeuses",
      "du désert chantant",
      "des plaines éternelles",
      "du canyon rouge",
      "du volcan endormi",
      "des falaises hurlantes",
      "de la grotte scintillante",
      "de la toundra gelée",
      "du lac miroir",
      "des eaux sombres",
      "des ruines oubliées",
      "des îles flottantes",
      "de la guilde des Inventeurs",
      "du clan des Loups-Rieurs",
      "de l'Ordre des Lanternes",
      "du Cercle des Sapins Sacrés",
      "de la Brigade des Balais Volants",
      "du Conseil des Six Tasses",
      "de la Légion Élastique",
      "de la Garde Rubiconde",
      "du chœur des Murmurants",
      "de la Tribu des Masques",

      /* -- AJOUTS -- */
      "du royaume des Oreillers",
      "de la vallée des Bulles",
      "du bosquet des Lanternes Dansantes",
      "de l’archipel Chamallow",
      "du glacier Arc-en-ciel"
    ],

    "capacities": [
      "au pas silencieux",
      "au cri paralysant",
      "au saut improbable",
      "à la vitesse supersonique",
      "capable de léviter",
      "capable de se dupliquer",
      "capable de disparaître",
      { "m": "manipulateur de flammes", "f": "manipulatrice de flammes" },
      { "m": "manipulateur de glace", "f": "manipulatrice de glace" },
      { "m": "manipulateur d'ombre", "f": "manipulatrice d'ombre" },
      { "m": "manipulateur de lumière", "f": "manipulatrice de lumière" },
      { "m": "résistant au poison", "f": "résistante au poison" },
      "insensible au froid",
      { "m": "infusé d'énergie stellaire", "f": "infusée d'énergie stellaire" },
      { "m": "né du crépuscule", "f": "née du crépuscule" },
      { "m": "imprégné de mana sauvage", "f": "imprégnée de mana sauvage" },
      "enfant de la lune",
      { "m": "lié au flux mystique", "f": "liée au flux mystique" },
      { "m": "porteur d'essence végétale", "f": "porteuse d'essence végétale" },
      { "m": "touché par la comète", "f": "touchée par la comète" },
      { "m": "béni par l'aurore", "f": "bénie par l'aurore" },
      { "m": "voyageur des plans", "f": "voyageuse des plans" },
      { "m": "teinté d'énergie chaotique", "f": "teintée d'énergie chaotique" },

      /* -- AJOUTS -- */
      "capable de parler aux nuages",
      "capable d’apprivoiser les éclairs",
      { "m": "maître des ricochets", "f": "maîtresse des ricochets" },
      "ami des lucioles",
      "protégé des vents doux"
    ],

    "equipments": [
      "à la moustache légendaire",
      "aux chaussettes enchantées",
      "à la chance insolente",
      "au look discutable",
      "aux oreilles radar",
      "aux dents multicolores",
      "à la cape dramatique",
      "à la démarche héroïque",
      "aux gestes théâtraux",
      "au talent culinaire douteux",
      "et son dragon de poche",
      "et son golem portatif",
      "et son chat spectral",
      "avec son bouclier bruyant",
      "avec son épée chantante",
      "avec son marteau retournable",
      "avec son sac à malices",
      { "m": "accompagné d'un écureuil stratégique", "f": "accompagnée d'un écureuil stratégique" },
      { "m": "accompagné d'un automate génial", "f": "accompagnée d'un automate génial" },
      "et son canon miniature",
      "avec son ballon dirigeable pliable",

      /* -- AJOUTS -- */
      "avec ses chaussures rebondissantes",
      "avec son caleçon musical",
      "avec son carnet de blagues secrètes",
      "à la veste phosphorescente",
      "à la montre qui rit"
    ],

    "custom": [
      "avec les doigts de pied en éventail",
      "fan de variété française",
      "qui a fait le tour du monde",
      "anthropologue amateur",
      {"m": "filmé par une caméra cachée", "f": "filmée par une caméra cachée"},
      {"m": "expert en sieste", "f": "experte en sieste"},
      {"m": "collectionneur de cailloux", "f": "collectionneuse de cailloux"},
      "de mauvaise foi",
      "qui traverse sans regarder",
      "au beurre de cacahuète",
      "qui a perdu son chargeur d'iphone",
      "ventriloque à ses heures",
    ]
  },

  "names": [
    { "word": "banane", "gender": "f", "emoji": "🍌" },
    { "word": "brocoli", "gender": "m", "emoji": "🥦" },
    { "word": "pomme", "gender": "f", "emoji": "🍎" },
    { "word": "carotte", "gender": "f", "emoji": "🥕" },
    { "word": "cactus", "gender": "m", "emoji": "🌵" },
    { "word": "champignon", "gender": "m", "emoji": "🍄" },
    { "word": "piment", "gender": "m", "emoji": "🌶️" },
    { "word": "citrouille", "gender": "f", "emoji": "🎃" },
    { "word": "raisin", "gender": "m", "emoji": "🍇" },
    { "word": "pastèque", "gender": "f", "emoji": "🍉" },

    { "word": "pizza", "gender": "f", "emoji": "🍕" },
    { "word": "hamburger", "gender": "m", "emoji": "🍔" },
    { "word": "taco", "gender": "m", "emoji": "🌮" },
    { "word": "nouille", "gender": "f", "emoji": "🍜" },
    { "word": "fromage", "gender": "m", "emoji": "🧀" },
    { "word": "croissant", "gender": "m", "emoji": "🥐" },
    { "word": "crêpe", "gender": "f", "emoji": "🥞" },
    { "word": "œuf", "gender": "m", "emoji": "🥚" },
    { "word": "baguette", "gender": "f", "emoji": "🥖" },

    { "word": "chat", "gender": "m", "emoji": "🐱" },
    { "word": "chien", "gender": "m", "emoji": "🐶" },
    { "word": "lapin", "gender": "m", "emoji": "🐰" },
    { "word": "hamster", "gender": "m", "emoji": "🐹" },
    { "word": "singe", "gender": "m", "emoji": "🐒" },
    { "word": "panda", "gender": "m", "emoji": "🐼" },
    { "word": "koala", "gender": "m", "emoji": "🐨" },
    { "word": "renard", "gender": "m", "emoji": "🦊" },
    { "word": "ours", "gender": "m", "emoji": "🐻" },
    { "word": "licorne", "gender": "f", "emoji": "🦄" },

    { "word": "grenouille", "gender": "f", "emoji": "🐸" },
    { "word": "poule", "gender": "f", "emoji": "🐔" },
    { "word": "canard", "gender": "m", "emoji": "🦆" },
    { "word": "aigle", "gender": "m", "emoji": "🦅" },
    { "word": "hibou", "gender": "m", "emoji": "🦉" },
    { "word": "pingouin", "gender": "m", "emoji": "🐧" },
    { "word": "dinde", "gender": "f", "emoji": "🦃" },
    { "word": "perroquet", "gender": "m", "emoji": "🦜" },
    { "word": "cygne", "gender": "m", "emoji": "🦢" },
    { "word": "corbeau", "gender": "m", "emoji": "🐦‍⬛" },
    { "word": "loutre", "gender": "f", "emoji": "🦦" },
    { "word": "abeille", "gender": "f", "emoji": "🐝" },
    { "word": "flamant", "gender": "m", "emoji": "🦩" },
    { "word": "avocat", "gender": "m", "emoji": "🥑" },
    { "word": "ours en peluche", "gender": "m", "emoji": "🧸" },
    { "word": "roller", "gender": "m", "emoji": "🛼" },
    { "word": "boîte", "gender": "f", "emoji": "📦" },

    { "word": "dragon", "gender": "m", "emoji": "🐉" },
    { "word": "démon", "gender": "m", "emoji": "😈" },
    { "word": "fantôme", "gender": "m", "emoji": "👻" },
    { "word": "alien", "gender": "m", "emoji": "👽" },
    { "word": "robot", "gender": "m", "emoji": "🤖" },
    { "word": "zombie", "gender": "m", "emoji": "🧟" },
    { "word": "squelette", "gender": "m", "emoji": "💀" },
    { "word": "elfe", "gender": "m", "emoji": "🧝‍♂️" },
    { "word": "sorcière", "gender": "f", "emoji": "🧙‍♀️" },

    { "word": "tortue", "gender": "f", "emoji": "🐢" },
    { "word": "dinosaure", "gender": "m", "emoji": "🦖" },
    { "word": "éléphant", "gender": "m", "emoji": "🐘" },
    { "word": "hippopotame", "gender": "m", "emoji": "🦛" },
    { "word": "rhinocéros", "gender": "m", "emoji": "🦏" },
    { "word": "girafe", "gender": "f", "emoji": "🦒" },
    { "word": "tigre", "gender": "m", "emoji": "🐯" },
    { "word": "lion", "gender": "m", "emoji": "🦁" },
    { "word": "zèbre", "gender": "m", "emoji": "🦓" },
    { "word": "chameau", "gender": "m", "emoji": "🐪" },

    { "word": "poisson", "gender": "m", "emoji": "🐟" },
    { "word": "requin", "gender": "m", "emoji": "🦈" },
    { "word": "baleine", "gender": "f", "emoji": "🐋" },
    { "word": "dauphin", "gender": "m", "emoji": "🐬" },
    { "word": "pieuvre", "gender": "f", "emoji": "🐙" },
    { "word": "crabe", "gender": "m", "emoji": "🦀" },
    { "word": "crevette", "gender": "f", "emoji": "🦐" },
    { "word": "huître", "gender": "f", "emoji": "🦪" },
    { "word": "homard", "gender": "m", "emoji": "🦞" },
    { "word": "méduse", "gender": "f", "emoji": "🪼" },

    { "word": "fusée", "gender": "f", "emoji": "🚀" },
    { "word": "bus", "gender": "m", "emoji": "🚌" },
    { "word": "train", "gender": "m", "emoji": "🚆" },
    { "word": "bateau", "gender": "m", "emoji": "⛵" },
    { "word": "tracteur", "gender": "m", "emoji": "🚜" },
    { "word": "vélo", "gender": "m", "emoji": "🚲" },
    { "word": "ambulance", "gender": "f", "emoji": "🚑" },

    { "word": "clé", "gender": "f", "emoji": "🗝️" },
    { "word": "horloge", "gender": "f", "emoji": "🕒" },
    { "word": "ampoule", "gender": "f", "emoji": "💡" },
    { "word": "cadenas", "gender": "m", "emoji": "🔒" },
    { "word": "cadeau", "gender": "m", "emoji": "🎁" },

    { "word": "livre", "gender": "m", "emoji": "📚" },
    { "word": "crayon", "gender": "m", "emoji": "✏️" },
    { "word": "trombone", "gender": "m", "emoji": "📎" },
    { "word": "enveloppe", "gender": "f", "emoji": "✉️" },

    { "word": "ballon", "gender": "m", "emoji": "🎈" },
    { "word": "masque", "gender": "m", "emoji": "🎭" },
    { "word": "clown", "gender": "m", "emoji": "🤡" },
    { "word": "tshirt", "gender": "m", "emoji": "👕" },
    { "word": "chaussette", "gender": "f", "emoji": "🧦" },
    { "word": "botte", "gender": "f", "emoji": "👢" },

    { "word": "nuage", "gender": "m", "emoji": "☁️" },
    { "word": "éclair", "gender": "m", "emoji": "⚡️" },
    { "word": "arc-en-ciel", "gender": "m", "emoji": "🌈" },
    { "word": "soleil", "gender": "m", "emoji": "☀️" },
    { "word": "lune", "gender": "f", "emoji": "🌙" },
    { "word": "étoile", "gender": "f", "emoji": "⭐" },
    { "word": "planète", "gender": "f", "emoji": "🪐" },
    { "word": "comète", "gender": "f", "emoji": "☄️" },
    { "word": "volcan", "gender": "m", "emoji": "🌋" },
    { "word": "montagne", "gender": "f", "emoji": "⛰️" },

    { "word": "chaise", "gender": "f", "emoji": "🪑" },
    { "word": "canapé", "gender": "m", "emoji": "🛋️" },
    { "word": "miroir", "gender": "m", "emoji": "🪞" },
    { "word": "bougie", "gender": "f", "emoji": "🕯️" },
    { "word": "parapluie", "gender": "m", "emoji": "☂️" },
    { "word": "valise", "gender": "f", "emoji": "🧳" },

    { "word": "guitare", "gender": "f", "emoji": "🎸" },
    { "word": "piano", "gender": "m", "emoji": "🎹" },
    { "word": "violon", "gender": "m", "emoji": "🎻" },
    { "word": "trompette", "gender": "f", "emoji": "🎺" },
    { "word": "tambour", "gender": "m", "emoji": "🥁" },
    { "word": "flûte", "gender": "f", "emoji": "🪈" },
    { "word": "microphone", "gender": "m", "emoji": "🎤" },

    { "word": "ballon de foot", "gender": "m", "emoji": "⚽" },

    { "word": "chapeau", "gender": "m", "emoji": "🎩" },
    { "word": "gant", "gender": "m", "emoji": "🧤" },
    { "word": "couronne", "gender": "f", "emoji": "👑" },
    { "word": "bague", "gender": "f", "emoji": "💍" },

    { "word": "rose", "gender": "f", "emoji": "🌹" },
    { "word": "tournesol", "gender": "m", "emoji": "🌻" },
    { "word": "tulipe", "gender": "f", "emoji": "🌷" },
    { "word": "marguerite", "gender": "f", "emoji": "🌼" },
    { "word": "arbre", "gender": "m", "emoji": "🌳" },

    { "word": "gâteau", "gender": "m", "emoji": "🎂" },
    { "word": "bonbon", "gender": "m", "emoji": "🍬" },
    { "word": "chocolat", "gender": "m", "emoji": "🍫" },
    { "word": "miel", "gender": "m", "emoji": "🍯" },
    { "word": "pain", "gender": "m", "emoji": "🍞" },
    { "word": "salade", "gender": "f", "emoji": "🥗" },
    { "word": "soupe", "gender": "f", "emoji": "🍲" },

    { "word": "diamant", "gender": "m", "emoji": "💎" },
    { "word": "trésor", "gender": "m", "emoji": "💰" },

    /* --- AJOUTS DE NOMS ORIGINAUX --- */

    { "word": "donut", "gender": "m", "emoji": "🍩" },
    { "word": "cookie", "gender": "m", "emoji": "🍪" },
    { "word": "popcorn", "gender": "m", "emoji": "🍿" },
    { "word": "patate", "gender": "f", "emoji": "🥔" },
    { "word": "sapin", "gender": "m", "emoji": "🎄" },
    { "word": "globe", "gender": "m", "emoji": "🌍" },

    { "word": "raclettier", "gender": "m", "emoji": "🫕" },
    { "word": "spirale", "gender": "f", "emoji": "🌀" },
    { "word": "patin", "gender": "m", "emoji": "⛸️" },
    { "word": "brique", "gender": "f", "emoji": "🧱" },

    { "word": "coquillage", "gender": "m", "emoji": "🐚" },
  ]
};


export default pseudoData;
